// extracted by mini-css-extract-plugin
export var chevron = "navigation-dropdown-module--chevron--3abef";
export var dropdown = "navigation-dropdown-module--dropdown--1977d";
export var dropdownheader = "navigation-dropdown-module--dropdownheader--745ff";
export var groupLink = "navigation-dropdown-module--groupLink--1cd41";
export var navbardropdown = "navigation-dropdown-module--navbardropdown--df2d6";